import { useState } from "react";
import axios from "axios";
import { DialogLayout } from "@/subframe/layouts/DialogLayout";
import { IconButton } from "@/subframe/components/IconButton";
import { IconWithBackground } from "@/subframe/components/IconWithBackground";
import { Button } from "@/subframe/components/Button";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { removeLabel } from "../../redux/reducers/authSlice";
import { addEsChatToConfig } from "../../Utils/apiUtils";

interface DeleteLabelPopupProps {
  labelId: number | undefined;
  open: boolean;
  setIsLabelDeleteOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function DeleteLabelPopup({
  labelId,
  open,
  setIsLabelDeleteOpen,
}: DeleteLabelPopupProps) {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDeleteLabel = async () => {
    if (!labelId) return;
    setLoading(true);
    setError(null);

    try {
      const config = addEsChatToConfig();
      
      await axios.delete(
        `https://api.insightssystem.com/api:bVXsw_FD/web/label_management/${labelId}`,
        config
      );
      dispatch(removeLabel(labelId));
      setIsLabelDeleteOpen(false);
    } catch (err) {
      setError("Failed to delete label");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DialogLayout open={open} onOpenChange={setIsLabelDeleteOpen}>
      <div className="flex flex-col items-start gap-4">
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-center justify-center bg-default-background px-6 py-6">
          <div className="flex w-full flex-col items-end gap-1">
            <IconButton
              className="h-auto w-auto flex-none"
              size="large"
              icon="FeatherX"
              onClick={() => setIsLabelDeleteOpen(false)}
            />
          </div>
          <div className="flex max-w-[320px] flex-col items-center justify-center gap-6">
            <IconWithBackground
              variant="error"
              size="large"
              icon="FeatherTrash2"
            />
            <div className="flex flex-col items-center justify-center gap-2">
              <div className="flex flex-col items-center gap-2">
                <span className="text-heading-2 font-heading-2 text-default-font text-center">
                  Delete Label?
                </span>
              </div>
              <span className="text-caption font-caption text-subtext-color text-center">
                This label will be permanently deleted for all users across all
                locations.
              </span>
            </div>
            {error && (
              <span className="text-red-500 text-sm text-center">{error}</span>
            )}
            <div className="flex w-full flex-col items-center justify-center gap-2">
              <div className="flex w-full flex-col items-start gap-2">
                <Button
                  className="h-8 w-full flex-none"
                  onClick={handleDeleteLabel}
                  disabled={loading}
                >
                  {loading ? "Deleting..." : "Delete"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DialogLayout>
  );
}

export default DeleteLabelPopup;
